<template>
  <div class="home">
    <app-header></app-header>
    <app-case-studies></app-case-studies>
    <app-footer></app-footer>
  </div>
</template>

<script>
// @ is an alias to /src
import Header from "@/components/general/Header.vue";
import CaseStudies from "@/components/casestudies/casestudies.vue";
import Footer from "@/components/general/Footer.vue";


export default {
name: "home",
components: {
  'app-header': Header,
  'app-case-studies': CaseStudies,
  'app-footer' : Footer,
  }
}   

</script>
